// Claim Offer Widget Gift JavaScript
(() => {
  // Cache DOM elements once
  const elements = {
    widget: document.querySelector('[data-offer-widget-gift]'),
    get claimButton() { return elements.widget?.querySelector('.claim-offer-widget-gift__button') },
    get textDisplay() { return elements.widget?.querySelector('.claim-offer-widget-gift__text') }
  };
  
  // Cache settings - will be populated when available
  let settings = {};
  
  // Make core functions globally available
  window.claimOfferWidgetGift = window.claimOfferWidgetGift || {};
  
  // Define functions on the global object
  window.claimOfferWidgetGift.getActiveOffer = function() {
    const utmSource = new URLSearchParams(window.location.search).get('utm_source') || 
                     sessionStorage.getItem('ghf_utm_source');
    if (!utmSource) return null;
    
    const offers = settings.offers || window.themeSettings?.claimOfferGift?.offers || [];
    const sortedOffers = [...offers].sort((a, b) => (a.priority || 0) - (b.priority || 0));
    
    return sortedOffers.find(offer => 
      offer.sources.some(source => utmSource.toLowerCase().includes(source.toLowerCase()))
    );
  };

  function openKlaviyoPopup(popupId) {
    console.log('Gift Widget: Opening Klaviyo popup with ID:', popupId);
    
    try {
      // Use the same method as original claim widget
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', popupId]);
      console.log('Gift Widget: Klaviyo popup triggered via _klOnsite queue');
      
      // Store that we opened popup via widget
      sessionStorage.setItem('ghf_popup_opened_via_widget', 'true');
      sessionStorage.setItem('ghf_last_popup_id', popupId);
      
      return true;
    } catch (error) {
      console.error('Gift Widget: Failed to open Klaviyo popup:', error);
      return false;
    }
  }

  window.claimOfferWidgetGift.showGiftModal = function(popupId) {
    if (popupId) {
      const success = openKlaviyoPopup(popupId);
      
      // Update button to show clicked state with subtle color change
      if (success && elements.claimButton) {
        elements.claimButton.style.backgroundColor = '#f0f4f8';
        elements.claimButton.style.borderColor = '#718096';
      }
    } else {
      console.error('Gift Widget: No popup ID provided');
    }
  };

  function waitForSettings() {
    return new Promise((resolve) => {
      function checkSettings() {
        if (window.themeSettings?.claimOfferGift?.offers) {
          settings = window.themeSettings.claimOfferGift;
          resolve(settings);
        } else {
          setTimeout(checkSettings, 100);
        }
      }
      checkSettings();
    });
  }

  async function initializeGiftWidget() {
    // Wait for settings to be available
    await waitForSettings();
    
    const activeOffer = window.claimOfferWidgetGift.getActiveOffer();
    if (!activeOffer || !elements.widget) {
      console.debug('Gift Widget: No active offer or widget element');
      return;
    }

    console.log('Gift Widget: Initializing for UTM sources:', activeOffer.sources);
    
    // Add mobile-only style
    if (!document.getElementById('mobile-gift-widget-style')) {
      const styleTag = document.createElement('style');
      styleTag.id = 'mobile-gift-widget-style';
      styleTag.textContent = `
        @media (min-width: 768px) {
          [data-offer-widget-gift] {
            display: none !important;
          }
        }
      `;
      document.head.appendChild(styleTag);
    }
    
    // Show the widget
    elements.widget.style.display = 'block';
    
    // Check if gift was already claimed via this widget
    const giftClaimed = sessionStorage.getItem('ghf_gift_claimed_via_widget');
    if (giftClaimed) {
      if (elements.claimButton) {
        elements.claimButton.textContent = 'GIFT CLAIMED!';
        elements.claimButton.style.backgroundColor = '#4CAF50';
        elements.claimButton.style.color = 'white';
        elements.claimButton.style.borderColor = '#4CAF50';
        elements.claimButton.disabled = true;
      }
      return;
    }
    
    // Setup claim button click handler
    if (elements.claimButton && !elements.claimButton.hasClickHandler) {
      elements.claimButton.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Gift Widget: Claim button clicked');
        window.claimOfferWidgetGift.showGiftModal(activeOffer.popupId);
      });
      elements.claimButton.hasClickHandler = true;
    }

    // Listen for gift completion to update button state
    document.addEventListener('gift:completed', (event) => {
      if (event.detail.success && window.multiGiftModal?.klaviyoTriggered) {
        console.log('Gift Widget: Gift selection completed');
        
        // Update button to show success
        if (elements.claimButton) {
          elements.claimButton.textContent = 'GIFT ADDED!';
          elements.claimButton.style.backgroundColor = '#4CAF50';
          elements.claimButton.style.color = 'white';
          elements.claimButton.style.borderColor = '#4CAF50';
          elements.claimButton.disabled = true;
        }
        
        // Store completed state
        sessionStorage.setItem('ghf_gift_claimed_via_widget', 'true');
        sessionStorage.setItem('ghf_gift_completed_timestamp', new Date().toISOString());
      }
    });

    console.log('Gift Widget: Initialized successfully');
  }

  // Initialize when ready with multiple fallbacks
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGiftWidget);
  } else {
    initializeGiftWidget();
  }

  // Also try to initialize after delays to ensure everything is loaded
  setTimeout(initializeGiftWidget, 500);
  setTimeout(initializeGiftWidget, 1000);
  setTimeout(initializeGiftWidget, 2000);
})(); 